import { useEffect } from 'react';

interface SchemaData {
  '@context': string;
  '@type': string | string[];
  [key: string]: any;
}

export function useSchema(schemaData: SchemaData | SchemaData[]) {
  useEffect(() => {
    const schemas = Array.isArray(schemaData) ? schemaData : [schemaData];
    const scriptElements: HTMLScriptElement[] = [];

    schemas.forEach((schema) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schema);
      script.setAttribute('data-schema', 'true');
      document.head.appendChild(script);
      scriptElements.push(script);
    });

    return () => {
      scriptElements.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
    };
  }, [schemaData]);
}
